/**
 * Created by piotr.pozniak@thebeaverhead.com on 21/10/2024
 */

import React, { useMemo } from "react";
import WebsiteMissingWarning from "../../WebsiteMissingWarning";
import WebsitesVerifiedInfo from "../../WebsiteVerifiedInfo";
import InstallAccordion from "../../InstallAccordion";
import ClipboardCopyInput from "../../../../component/ClipboardCopyInput";
import FeatureFlag from "../../../../component/FeatureFlag";
import {
  getInstallDivTag,
  getInstallIframeTag,
  installScripTag,
} from "../../../../templates/WidgetPageTemplate/InstallTab/helpers";
import { experimentalListStyle } from "../../StandardInstall";

const ChurchCoInstructions = ({
  uuid,
  slug,
  widgetType,
  widgetTypePrintable,
  onGoToAddWebsite,
  widgetTemplate,
}) => {
  const installDiv = useMemo(
    () => installScripTag + getInstallDivTag(widgetType, uuid, widgetTemplate),
    [widgetType, uuid]
  );

  const installDivIframe = useMemo(
    () =>
      installScripTag +
      getInstallIframeTag(widgetType, uuid, slug, widgetTemplate),
    [widgetType, uuid, slug]
  );
  return (
    <div>
      <FeatureFlag name={"churchco-embeddable"}>
        <div className={"w-100 d-flex align-items-center flex-column"}>
          <p className={"text-center"}>
            Watch our tutorial video below or{" "}
            <a
              target={"_blankWordpressInstructions"}
              href={
                "https://help.display.church/en/articles/6690434-the-church-co-embedding-your-view"
              }
            >
              Read our Article
            </a>
            .
          </p>
          <div className={"install-modal--video-tutorial"}>
            <div>
              <iframe
                src="https://player.vimeo.com/video/765663052?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                title="Embedding into Wordpress"
              ></iframe>
            </div>
            <script src="https://player.vimeo.com/api/player.js"></script>
          </div>
        </div>
      </FeatureFlag>

      <div className={"my-4"}>
        <WebsiteMissingWarning onAddWebsite={onGoToAddWebsite} />
        <WebsitesVerifiedInfo />
      </div>
      <InstallAccordion
        title={`Recommended installation`}
        expandable={true}
        defaultExpanded={true}
      >
        <ol>
          <li>
            Navigate to your The Church Co <strong>dashboard</strong> and click
            on <strong>Pages</strong>.
          </li>
          <li>
            Select the page on which you wish to embed the {widgetTypePrintable}
            .
          </li>
          <li>
            Choose <strong>Visual Editor</strong>
          </li>
          <li>
            Click on <strong>New Page Builder Block</strong>.
          </li>
          <li>
            Select an
            <strong>HTML Embed</strong> block. The block will open. Code
            Injection.
          </li>
          <li>
            Click on the <strong>Code</strong> tab.
          </li>
          <li>
            Copy and Paste the following snippet in the{" "}
            <strong>HTML code</strong> field.
            <ClipboardCopyInput
              id={"embeddable_script"}
              value={installDiv}
              placeholder={`${widgetTypePrintable} embeddable script`}
            />
          </li>
          <li>
            Click <strong>Save</strong> to confirm your changes.
          </li>
        </ol>
      </InstallAccordion>
      <InstallAccordion
        title={`Experimental Installation (Fallback Method)`}
        expandable={true}
        defaultExpanded={false}
      >
        <p>
          This is a fallback method to use if your website theme employs an
          aggressive stylesheet that prevents the {widgetTypePrintable} from
          displaying properly. While this option may help embed the{" "}
          {widgetTypePrintable}
          effectively, it's important to note that it may not offer the same
          visual integration as the recommended methods. Note: This method will
          embed your widget in the iframe on website.
        </p>
        <ol>
          <li>
            Navigate to your The Church Co <strong>dashboard</strong> and click
            on <strong>Pages</strong>.
          </li>
          <li>
            Select the page on which you wish to embed the {widgetTypePrintable}
            .
          </li>
          <li>
            Choose <strong>Visual Editor</strong>
          </li>
          <li>
            Click on <strong>New Page Builder Block</strong>.
          </li>
          <li>
            Select an
            <strong>HTML Embed</strong> block. The block will open. Code
            Injection.
          </li>
          <li>
            Click on the <strong>Code</strong> tab.
          </li>
          <li>
            Copy and Paste the following snippet in the{" "}
            <strong>HTML code</strong> field.
            <ClipboardCopyInput
              id={"embeddable_script_iframe"}
              value={installDivIframe}
              placeholder={`${widgetTypePrintable} embeddable script`}
            />
          </li>
          <li>
            Click <strong>Save</strong> to confirm your changes.
          </li>
        </ol>
        <div className={"alert alert-warning"}>
          <ul style={experimentalListStyle}>
            <li>
              By using this experimental installation, you can overcome display
              issues caused by your theme’s styles, but be mindful that it may
              not provide the optimal user experience.
            </li>
          </ul>
        </div>
      </InstallAccordion>
    </div>
  );
};

export default ChurchCoInstructions;
